import Enum from "../../../../../../enums/Enum";

const DermatomesDropdownValues = new Enum({
    D0: {name: "Absent"},
    D1: {name: "Altered"},
    D2: {name: "Normal"},
    DNT: {name: "Not testable"}
});

export default DermatomesDropdownValues;